import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot, UrlTree } from '@angular/router';
import { UserStoreService } from '@core/services/user-store/user-store.service';
import { AuthGuardData, createAuthGuard } from 'keycloak-angular';
import { filter, firstValueFrom, take } from 'rxjs';

const isAccessAllowed = async (
  _route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot,
  authData: AuthGuardData
): Promise<boolean | UrlTree> => {
  const userService = inject(UserStoreService);

  if (!authData.authenticated) {
    await authData.keycloak.login().catch((e) => console.error(e));
    return false;
  }

  return firstValueFrom(userService.isAuthenticated$.pipe(filter(Boolean), take(1)));
};

export const AuthSsoGuard = createAuthGuard<CanActivateFn>(isAccessAllowed);
